var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00066 8.95034C5.71984 8.95034 5.49219 8.72269 5.49219 8.44187V5.59441C5.49219 5.31359 5.71984 5.08594 6.00066 5.08594C6.28148 5.08594 6.50914 5.31359 6.50914 5.59441V8.44187C6.50914 8.72269 6.28148 8.95034 6.00066 8.95034Z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00066 4.3096C5.86581 4.3096 5.73647 4.25603 5.64112 4.16067C5.54576 4.06532 5.49219 3.93598 5.49219 3.80113V3.56316C5.49219 3.28234 5.71984 3.05469 6.00066 3.05469C6.28148 3.05469 6.50914 3.28234 6.50914 3.56316V3.80113C6.50914 3.93598 6.45557 4.06532 6.36021 4.16067C6.26485 4.25603 6.13552 4.3096 6.00066 4.3096Z",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C11.9966 9.31231 9.31231 11.9966 6 12ZM6 1.01695C3.24794 1.01695 1.01695 3.24794 1.01695 6C1.01695 8.75206 3.24794 10.9831 6 10.9831C8.75206 10.9831 10.9831 8.75206 10.9831 6C10.9797 3.24933 8.75067 1.02031 6 1.01695Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipImage);
export default __webpack_public_path__ + "static/media/tooltip-image.049ba7ad00d7570724fec1184a750ff8.svg";
export { ForwardRef as ReactComponent };